<template>
  <div class="rounded-bl-md po-password-strength-bar" :class="passwordClass"></div>
</template>

<script setup lang="ts">
import { computed } from "vue";

enum NameScore {
  zero,
  one,
  two,
  three,
  four,
}

const emit = defineEmits(["score"]);
const props = defineProps({
  password: String,
  minLength: {
    type: Number,
    default: 8,
  },
});

function scorePassword(pass: string, minLength: number): NameScore {
  const lengthOk = pass.length >= minLength;
  const hasUpper = /[A-Z]/.test(pass);
  const hasLower = /[a-z]/.test(pass);
  const hasNumber = /[0-9]/.test(pass);

  let score = 0;
  if (lengthOk) ++score;
  if (hasUpper) ++score;
  if (hasLower) ++score;
  if (hasNumber) ++score;

  return score as NameScore;
}

const passwordClass = computed(() => {
  if (!props.password) {
    return null;
  }
  const score = scorePassword(props.password, props.minLength);
  const strength = NameScore[score];
  emit("score", score);
  // console.log(strength);
  return {
    [strength]: true,
    scored: true,
    "rounded-br-md": score === NameScore.four,
  };
});
</script>

<style>
.po-password-strength-bar {
  transition: all 0.2s linear;
  height: 5px;
}
.po-password-strength-bar.one {
  background-color: #f95e68;
  width: 25%;
}
.po-password-strength-bar.two {
  background-color: #fb964d;
  width: 50%;
}
.po-password-strength-bar.three {
  background-color: #fdd244;
  width: 75%;
}
.po-password-strength-bar.four {
  background-color: #35cc62;
  width: 100%;
}
</style>
